// extracted by mini-css-extract-plugin
export default {"item":"iLa48QcU49zQdyI0y9R5","container":"iDTfiSBW4K18hDRJKPQQ"};